// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";

// Please note - this should be kept up to date with
// MODIFY_YES elements in EOrderState in Flex -dc
export const ALLOWED_TO_REMOVE_LEG = new Set([
  CubiqTS.OrderState.PENDING_CANCELLATION,
  CubiqTS.OrderState.SAVED,
  CubiqTS.OrderState.ACTIVE,
  CubiqTS.OrderState.REJECTED,
  CubiqTS.OrderState.PENDING,
  CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.IN_MODIFICATION,
  CubiqTS.OrderState.REJECTED,
  CubiqTS.OrderState.SUSPENDED,
  CubiqTS.OrderState.MANUAL_PRICING,
  CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED,
  // Not included in Flex- are we mistaken in html?
  CubiqTS.OrderState.TRIGGERED,
  // ERROR - ui states
  // PROCESSING - ui state,
  // orders before submitting to the server have a null state
  // and are removable, but please check seperately.
]);
